<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nR6Dqe/tc-custom/9781449485672.jpg?1729082603344" alt="This image is the cover for the book Snoopy to the Rescue, Peanuts Kids"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Snoopy to the Rescue, Peanuts Kids
      </h1>
      <p class="bookDescription body article font2">
        <b>The world needs a hero—and Snoopy is ready to save the day!</b><br/><br/> <br/><br/>In times of struggle—an attack of crabbiness, a stolen piano, a depressed bird—Snoopy’s on the scene. Helping the Peanuts gang through various adventures (and misadventures), Snoopy continues his standoff with the Red Baron, finds every opportunity to kiss Lucy on the nose, and ventures out to find the mysterious Lila. Meanwhile, Charlie Brown faces anxiety over saying good-bye, Lucy tries ever more desperately to get Schroeder to notice her, and Linus ponders what life would be like without his blanket. Can Snoopy save the day? Find out in this collection of the classic Peanuts comics. <br/><br/>“Schulz’s masterpiece remains . . . relevant and funny for all ages generation after generation.” —<i>Good Comics for Kids, a School Library Journal Blog</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles M. Schulz
      </h2>
      
      <p class="authorDescription body article">From his earliest memories, Charles M. Schulz knew that all he wanted to do was &ldquo;draw funny pictures.&rdquo; Schulz was born in Minneapolis, Minnesota, in 1922, and his love for cartoons was fostered by his father in a shared appreciation for the&#160;Sunday&#160;funnies. As a senior in high school, at the prompting of his mother,&#160;he completed a correspondence cartoon course with the Federal School of Applied Cartooning. Schulz continued his studies in art as the genre of the cartoon began to change&mdash;adopting simplistic, minimalistic styles that, conveniently, allowed Schulz to showcase his dry, self-effacing humor.<BR /><BR /> In 1943 Schulz enlisted in the army to help the American efforts in World War II, ultimately returning home in the fall of 1945. In a push to make his dream of being a cartoonist a reality, he taught at his alma mater and sold cartoon strips to papers intermittently. Finally, in October 1950, the first <I>Peanuts</I>&#160;strip premiered in seven national newspapers. His seemingly simple creation&mdash;illustrations of large-headed kids using vocabulary and facing situations far beyond their years&mdash;became a well-known, well-loved comic strip and grew to have an enormous global impact.<BR /><BR /> Schulz himself has won awards from his cartoonist peers, has been recognized and lauded by U.S. and foreign governments, and has received Emmys for his animated specials. In 2015 the beloved holiday TV special&mdash;<I>A Charlie Brown Christmas</I>&mdash;will reach its fifty-year milestone. Though the last original <I>Peanuts</I> comic appeared in papers on February 13, 2000, the day after Schulz passed away in his sleep, his work continues to be read in more than two thousand newspapers around the world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6454990e